module.exports = __webpack_public_path__ + "img/dr-nate-schanuth-schanuth-family-chiropractic.711f75e8.jpg";